import React from "react";
import { siteConfig } from "../../config/siteConfig";

const Testimonials = () => {
  const { testimonials } = siteConfig;

  return (
    <section id="incluye" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <span className="text-sm font-bold text-violet-600 uppercase tracking-wider">{testimonials.eyebrow}</span>
          <h2 className="text-4xl md:text-5xl font-black mt-4 mb-6 bg-gradient-to-r from-slate-900 to-slate-700 bg-clip-text text-transparent">
            {testimonials.title}
          </h2>
          <p className="text-xl text-slate-600">{testimonials.subtitle}</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
          {testimonials.items.map((item, index) => (
            <div key={index} className="bg-white p-8 rounded-3xl border border-slate-200 shadow-lg hover:shadow-xl transition-shadow">
              <div className="w-12 h-12 rounded-2xl bg-gradient-to-br from-violet-600 to-purple-600 flex items-center justify-center text-2xl mb-6">
                {item.icon}
              </div>
              <h4 className="font-bold text-slate-900 mb-3">{item.title}</h4>
              <p className="text-sm text-slate-600 leading-relaxed">{item.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
